import React from 'react';
// @ts-ignore
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-daterangepicker/daterangepicker.css';
import moment from 'moment';

interface DateRangePickerProps {
    startDate: moment.Moment;
    endDate: moment.Moment;
    onChange: (start: moment.Moment, end: moment.Moment) => void;
}

export const CustomDateRangePicker: React.FC<DateRangePickerProps> = ({
                                                                          startDate,
                                                                          endDate,
                                                                          onChange,
                                                                      }) => {
    const ranges = {
        Today: [moment(), moment()],
        Yesterday: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
        'Last 7 Days': [moment().subtract(6, 'days'), moment()],
        'Last 30 Days': [moment().subtract(29, 'days'), moment()],
        'This Month': [moment().startOf('month'), moment().endOf('month')],
        'Last Month': [
            moment().subtract(1, 'month').startOf('month'),
            moment().subtract(1, 'month').endOf('month'),
        ],
    };

    return (
        <div className="date-range-wrapper">
            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="calendar-icon"
            >
                <path
                    d="M21 10H3M16 2V6M8 2V6M7.8 22H16.2C17.8802 22 18.7202 22 19.362 21.673C19.9265 21.3854 20.3854 20.9265 20.673 20.362C21 19.7202 21 18.8802 21 17.2V8.8C21 7.11984 21 6.27976 20.673 5.63803C20.3854 5.07354 19.9265 4.6146 19.362 4.32698C18.7202 4 17.8802 4 16.2 4H7.8C6.11984 4 5.27976 4 4.63803 4.32698C4.07354 4.6146 3.6146 5.07354 3.32698 5.63803C3 6.27976 3 7.11984 3 8.8V17.2C3 18.8802 3 19.7202 3.32698 20.362C3.6146 20.9265 4.07354 21.3854 4.63803 21.673C5.27976 22 6.11984 22 7.8 22Z"
                    stroke="#01080F"
                    strokeWidth="1.66667"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>

            <DateRangePicker
                initialSettings={{
                    startDate,
                    endDate,
                    opens: 'center',
                    showDropdowns: false,
                    autoUpdateInput: true,
                    alwaysShowCalendars: true,
                    ranges: ranges,
                    locale: {format: 'YYYY-MM-DD'},
                }}
                onCallback={(start: any, end: any) => {
                    onChange(start, end);
                }}
            >
                <input
                    type="text"
                    className="form-control"
                    defaultValue={`${startDate.format('YYYY-MM-DD')} - ${endDate.format(
                        'YYYY-MM-DD'
                    )}`}
                    placeholder="Select date range"
                />
            </DateRangePicker>
        </div>
    );
};
